import { isDefined } from '../../utilities/is-defined';

export type PwaPushNotification = {
    action: string;
    notification: NotificationOptions & {
        title: string;
    };
};

// ADA:  New notification assigned
// REFR: Existing notification change somehow, e.g. update longtext, material assigned, ...
// AVR1: Notification was cancelled
export type PushNotificationType = 'ADA' | 'REFR' | 'AVR1';

export type PushNotificationUpdateForNotification = PwaPushNotification & {
    notification: {
        data: {
            notificationNumber: string;
            taskNumber: string;
            gid: string;
            type: PushNotificationType;
        };
    };
};

export type AdditionalDataPushNotificationUpdate = PushNotificationUpdateForNotification & {
    additionalData: {
        data: string;
    };
};

export function isPushNotificationUpdateForNotification(
    pushUpdateForNotification: unknown,
): pushUpdateForNotification is PushNotificationUpdateForNotification {
    return (
        isDefined((pushUpdateForNotification as PushNotificationUpdateForNotification)?.notification?.data?.gid) &&
        isDefined(
            (pushUpdateForNotification as PushNotificationUpdateForNotification)?.notification?.data
                ?.notificationNumber,
        ) &&
        isDefined((pushUpdateForNotification as PushNotificationUpdateForNotification)?.notification?.data?.taskNumber)
    );
}
